/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type Locale } from '@/types/i18n';

export const brandsPrefix: Record<Locale, string> = {
  'en-US': 'brands',
  'es-MX': 'marcas',
  'pt-BR': 'marcas',
};
